import DOMPurify from 'dompurify'
import type { DirectiveBinding } from 'vue'

DOMPurify.addHook('afterSanitizeAttributes', (node: Element) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank')
    node.setAttribute('rel', 'noopener noreferrer')
})

export const sanitizedHtml = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    el.innerHTML = sanitizeHTML(binding.value)
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    if (binding.value !== binding.oldValue)
      el.innerHTML = sanitizeHTML(binding.value)
  },
}

function sanitizeHTML(html: string) {
  return DOMPurify.sanitize(html, { ADD_ATTR: ['target'] })
}
